import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useEffect, useState } from "react";
import { recruitApi } from "../service/apis/pages.api";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader/loader";
import { Modal, Button } from "react-bootstrap";

const OurRecruitmentServicesScreen = () => {
    const navigate = useNavigate();
    const [responseData, setResponseData] = useState<any>([]);
    const [titleSlug, setTitleSlug] = useState<any>(null);
    const [ , setIsLoading] = useState(false);

    const recruitContents = async() => {
        setIsLoading(true);
        try {
            const response = await recruitApi();
            setResponseData(response?.pageData?.pageContent);
            setTitleSlug(response?.pageData);
        } catch (error) {
            console.error("Catch Error: ", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        recruitContents();
    }, []);

    const recruit_texts = responseData[0]?.formFieldRepeater;

    const decodeHtml = (html ="") => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }; 

    const sanitizeData = (htmldata = "") => {
        const sanitizedDescription = decodeHtml(htmldata);
        return (
          <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
        );
    };

    const [show, setShow] = useState(false);
    const [modalContent, setModalContent] = useState("");

    const handleShow = (content: any) => {
        setModalContent(content);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    return (
        <>
            <div className="front-pages">
                <section className="home-banner innerBanner position-relative common-padd-xl">
                    <div className="homeLine"><img src={Innerbannerlines} alt="line icon" /></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="innerBanner-info text-center">
                                    {titleSlug && (
                                        <h1>{titleSlug?.title}</h1>
                                    )}
                                    <div className="breadcrumb-holder text-center">
                                        <Breadcrumb>
                                            <Breadcrumb.Item onClick={() => navigate('/')}><img src={Logoicon} alt="logo icon" /> Home</Breadcrumb.Item>
                                            <Breadcrumb.Item active>{titleSlug?.title}</Breadcrumb.Item>
                                        </Breadcrumb>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="serviceslist-area position-relative common-padd-xl pt-0">
                    <div className="container">
                        <div className="row">
                            {recruit_texts ? ( recruit_texts.map((rec: any, index: any) => (
                                <div key={index} className="col-lg-4">
                                    <div className="srvcard-holder">
                                        <div className="srvcardImg">
                                            {rec[1]?.type === "image" && rec[1]?.content && (
                                                <img src={rec[1]?.content} alt={rec[0]?.content} />
                                            )}
                                        </div>
                                        <div className="srvcardInfo">
                                            {rec[0]?.type === "text" && rec[0]?.content && (
                                                <h3 title={rec[0]?.content}>
                                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid  */}
                                                    {rec[0]?.content}
                                                </h3>
                                            )}
                                            {rec[2]?.type === "editor" && rec[2]?.content && (
                                                sanitizeData(rec[2]?.content)
                                            )}

                                            <Button variant="primary" onClick={() => handleShow(rec[2]?.content)}>
                                                Read More
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                                ))
                            ) : (
                                <Loader/>
                            )}

                        </div>
                    </div>
                </section>
            </div>

            {/* Modal Component */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Body>
                {sanitizeData(modalContent)}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default OurRecruitmentServicesScreen;